import { CarbonIconType } from '@carbon/icons-react';
import classNames from 'classnames';
import * as React from 'react';

export interface IconProps {
  'data-testid'?: string;
  className?: string;
  theme?: 'light' | 'dark';
  size: number;
  testId?: never;
}

export type IconComponentType =
  | React.FunctionComponent<IconProps>
  | CarbonIconType;

export type IconWrapperProps = Omit<
  IconProps,
  'data-testid' | 'size' | 'testId'
> & {
  'data-testid'?: never;
  size: 'xl' | 'lg' | 'md' | 'sm' | 'xs' | '2xs' | '3xs' | number;
  testId?: string;
};

export const ICON_SIZE: Record<IconWrapperProps['size'], number> = {
  xl: 32,
  lg: 24,
  md: 20,
  sm: 16,
  xs: 14,
  '2xs': 12,
  '3xs': 10,
};

export const Icon: React.VFC<
  IconWrapperProps & {
    IconComponent: IconComponentType;
  }
> = ({ IconComponent, className, size, testId, ...props }) => (
  <IconComponent
    className={classNames(className, 'vb-icon')}
    data-testid={testId}
    size={typeof size === 'string' ? ICON_SIZE[size] : size}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />
);
